<template>
    <div class="optimize-methods-content" v-if="newOptimize">
        <h2 class="primary-color m-b-8">{{ $t('optimize_image.modal_optimization_methods.title') }}</h2>
        <p class="m-b-16">{{ $t('optimize_image.modal_optimization_methods.description') }}</p>
        <div :class="[$prefixClass.card + '-stroke optimize-methods-options']">
            <img v-if="onBoardingScreen || showBanner" src="@/assets/images/opimize-actual.svg" alt=""/>
            <a-form-model ref="formSettings" :model="formSettings">
                <transition name="fade-in" mode="out-in" v-if="optimizeError">
                    <vue-error-box class="m-b-16" :error="$t('app.components.choose_at_least_one_method')"></vue-error-box>
                </transition>
                <a-form-model-item prop="optimize_image" v-if="!isUsingv3">
                    <div class="d-flex align-items-center">
                        <a-switch v-model="formSettings.optimize_image"
                        :prefixCls="$prefixClass.switch"/>
                        <strong for="optimize_image" class="m-l-8">{{ $t('app.components.optimize_image') }}</strong>
                        <!-- <a-tooltip :prefixCls="$prefixClass.tooltip" 
                            class="m-l-8" 
                            placement="right"
                            :overlayClassName="'optimize-methods-content__tooltip'"
                            title="We use Smart Lossy Compression to optimize images.">
                            <i class="fal fa-question-circle cursor-pointer fz-12"></i>
                        </a-tooltip> -->
                    </div>
                    <div class="m-t-20" v-if="loadingImage.visible && onBoardingScreen">
                        <div class="optimize-methods-options__progress m-b-16">
                            <div class="display-space-between">
                                <span>{{ $t('optimize_image.modal_optimization_methods.scanning_images') }}</span>
                                <h6 class="m-0">{{ loadingImage.percent }}%</h6>
                            </div>
                            <vue-progress-bar :percent="loadingImage.percent">
                            </vue-progress-bar>
                        </div>
                        <span>{{ $t('optimize_image.modal_optimization_methods.scanning_description') }}</span>
                    </div>
                    <template v-else>
                        <div class="d-flex m-t-16">
                            <div class="m-r-80">
                                <span class="text-color-secondary">{{ $t('app.components.found') }}</span>
                                <h5 class="m-0"> {{ newOptimize.image.total }} {{ $t('app.components.images') }}</h5>
                            </div>
                            <div>
                                <span class="text-color-secondary">{{ $t('app.components.potential_saving') }}</span>
                                <h5 :class="['m-0', newOptimize.image.total_saved ? 'success-color' : '']">{{ formatSize(newOptimize.image.total_saved) }}</h5>
                            </div>
                        </div>
                        <h6 v-if="newOptimize.image.total > maximumOptimize" class="fz-14 text-color-secondary m-0 m-t-12">{{ $t('app.components.optimize_your_first', {num: newOptimize.image.total}) }}</h6>
                        <span style="font-style: italic;" class="fz-14 text-color-secondary">{{$t('app.components.optimize_description')}}</span>
                        <span style="font-style: italic; display: block;" class="fz-14 text-color-secondary" v-html="$t('app.components.optimize_description_two', {link: 'https://help.perfectapps.io/en/article/why-i-can-not-restore-my-images-svg9wl/?bust=1649054259123'})"></span>
                    </template>
                </a-form-model-item>

                <a-form-model-item prop="optimize_theme">
                    <div class="display-space-between align-items-center">
                        <div class="d-flex align-items-center">
                            <a-switch v-model="formSettings.optimize_theme"
                                :prefixCls="$prefixClass.switch"/>
                            <strong for="optimize_theme" class="m-l-8">{{ $t('app.components.optimize_theme') }}</strong>
                        </div>
                        <a :class="[$prefixClass.link, !formSettings.optimize_theme ? 'field-disabled' :'']" @click="handleSelectAll()">{{checkAll ? 'Select all' : 'Unselect all'}}</a>
                    </div>
                </a-form-model-item>
                <transition name="fade-in" mode="out-in" v-if="themeError">
                    <p class="danger-color m-t-8 m-b-0"> {{ $t('app.components.choose_at_least_one_theme') }}</p>
                </transition>
                <a-form-model-item class="list-optimize-theme">
                    <a-checkbox-group
                        :class="['m-t-8', !formSettings.optimize_theme ? 'field-disabled' :'']"
                        v-model="formSettings.settings"
                        name="checkboxgroup"
                        :options="listThemeOpt"
                        />
                </a-form-model-item>
            </a-form-model>
        </div>
        <div :class="['m-t-24 text-right', onBoardingScreen ? 'display-space-between align-items-center' : '']">
            <a-button v-if="onBoardingScreen" type="subtle" @click="$emit('on-back')">
                <i class="fas fa-chevron-left m-r-8 fw-300 fz-14"></i>Back
            </a-button>
            <div>
                <a-button class="m-r-8" key="cancel" @click="handleCancel" v-html="$t('app.buttons.cancel')"></a-button>
                <a-button key="submit" type="primary" :disabled="isDisabled" @click="handleOptimize" v-html="$t('app.buttons.optimize')"></a-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters  } from 'vuex'
import { types as typesOptimize } from '@/modules/optimize_image/constant'
import Pusher from "pusher-js"
var fakePercent;
export default {
    name: 'VueOptimizeMethodContent',
    props:{
        value: {
            type: Object,
            required: true
        },
        showBanner: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isModify: false,
            isDisabled: false,
            optimizeError: false,
            themeError: false,
            checkAll: false,
            loadingImage: {
                visible: false,
                percent: 0
            },
            formSettings: {
                optimize_image: false,
                optimize_theme: false,
                settings: []
            },
            isUsingv3: true,
            listThemeOpt: [
                {
                    value: 'lazyload',
                    label: this.$t('app.components.lazy_load_images')
                },
                {
                    value: 'preload_font',
                    label: this.$t('app.components.preload_web_fonts')
                },
                {
                    value: 'minify_css',
                    label: this.$t('app.components.minify_css_files')
                },
                {
                    value: 'minify_js',
                    label: this.$t('app.components.minify_javascript_files')
                },
                {
                    value: 'critical_css',
                    label: this.$t('app.components.extract_critical_css')
                },
            ],
        }
    },
    computed: {
        ...mapGetters({
            newOptimize: typesOptimize.getters.GET_NEW_OPTIMIZE
        }),
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', this.value)
            }
        },
        onBoardingScreen() {
            return this.$router.currentRoute.name == this.$routerName.ONBOARD_SET_UP
        },
        optimizeImageSreen() {
            return this.$router.currentRoute.name == this.$routerName.OPTIMIZE_IMAGE
        }
    },
    watch:{
        formSettings: {
            handler() {
                this.isModify = true
                this.isDisabled = !this.formSettings.optimize_image && !this.formSettings.optimize_theme || (this.formSettings.optimize_theme && this.formSettings.settings.length <= 0)
                this.optimizeError = !this.formSettings.optimize_theme && !this.formSettings.optimize_image
                this.themeError = this.formSettings.optimize_theme && this.formSettings.settings.length <= 0
            },
            deep: true
        }
    },
    mounted () {
        let _this = this
        window.addEventListener('beforeunload', function (event) {
            if(_this.isModify){
                event.returnValue = true
            }
        }, false)
    },
    created() {
        if ( !this.newOptimize ) {
            this.checkNewOptimize()
        }
        this.formSettings = this.$clone(this.modal.formSettings)
        this.isDisabled = !this.formSettings.optimize_image && !this.formSettings.optimize_theme || (this.formSettings.optimize_theme && this.formSettings.settings.length <= 0)
        this.optimizeError = !this.formSettings.optimize_theme && !this.formSettings.optimize_image
        this.themeError = this.formSettings.optimize_theme && this.formSettings.settings.length < 0
        this.listenLoadingImagePusher()
    },
    methods: {
        ...mapActions({
            checkNewOptimize: typesOptimize.actions.CHECK_NEW_OPTIMIZE
        }),
        handleCancel() {
            this.$emit('cancel')
        },
        handleOptimize() {
            this.$emit('handle-optimize', this.formSettings)
        },
        handleSelectAll() {
            this.formSettings.settings = []
            if ( this.checkAll ) {
                this.listThemeOpt.forEach(technical => {
                    this.formSettings.settings.push(technical.value)
                });
            }
            this.checkAll = !this.checkAll;
        },
        listenLoadingImagePusher() {
            // clearInterval(fakePercent)
            // fakePercent = setInterval(() => {
            //     if (this.loadingImage.percent < 100) {
            //         this.loadingImage.percent += 1
            //     }
            //     if(this.loadingImage.percent >= 100){
            //         setTimeout(() => {
            //             this.loadingImage.visible = false
            //         }, 500)
            //         clearInterval(fakePercent)
            //     }
            // }, 300)
        }
    }
}
</script>
<style lang="scss">
    .optimize-methods-content {
        .optimize-methods-options {
            text-align: left;
            &__progress {
                width: 328px;
                > div {
                    width: 100%;
                }
                .m-progress-bar, .m-progress-bar-inner, .m-progress-bar-outer {
                    display: unset !important;
                }
                .m-progress-bar {
                    > div:first-child {
                        background: #e8e8e8;
                    }
                }
            }
            form {
                padding: 24px 32px 32px 32px;
            }
        }
        &__tooltip {
            .m-tooltip-inner {
                padding: 8px 16px !important;
                width: fit-content;
                white-space: nowrap;
            }
        }
        .list-optimize-theme {
            margin-left: -12px;
            .#{$checkbox}-wrapper {
                width: 200px
            }
        }
        .#{$checkbox}-group {
            .a-checkbox-inner {
                width: 14px;
                height: 14px;
            }
            &-item {
                padding: 4px 12px;
                .#{$checkbox}+span {
                    display: inline;
                }
            }
        }
        .#{$checkbox}-wrapper+.#{$checkbox}-wrapper {
            margin-left: 0;
        }
    }
</style>
